import { useEffect, useState } from "react";
import mixpanel from "mixpanel-browser";
import cn from "app/utils/classnames";
import MenuButton from "app/ui/MenuButton";
import useGameData from "app/game-data/useGameData";
import useShareText from "app/game-over/useShareText";

interface ShareButtonProps {
  className?: string;
}

function isMobileBrowser(): boolean {
  const userAgent = navigator.userAgent;

  return /iPhone|iPad|iPod|android|IOS/i.test(userAgent);
}

export default function ShareButton({ className }: ShareButtonProps) {
  const data = useGameData();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const { copyToClipboard, isCopied, setCopied, navigatorShareText } =
    useShareText();

  useEffect(() => {
    setIsMobile(isMobileBrowser());
  }, []);

  function share() {
    mixpanel.track("share", {
      game_id: data?.id,
    });

    if (!isMobile) {
      copyToClipboard();
      return;
    }

    try {
      navigatorShareText();
    } catch {
      copyToClipboard();
    }
  }

  return (
    <div className={cn("relative", className)}>
      <MenuButton className="px-3 max-w-56" onClick={share}>
        Share Results
      </MenuButton>

      {isCopied && (
        <div
          className="animate-bubble-fade-out pointer-events-none absolute left-1/2 top-full z-10 w-max -translate-x-1/2 -translate-y-1/2 bg-white px-4 py-2 text-sm font-medium shadow-sm"
          onAnimationEnd={() => setCopied(false)}
        >
          Copied to clipboard
        </div>
      )}
    </div>
  );
}
